module.exports = __webpack_public_path__ + "static/media/no_data_table.d0e6394b.svg";